import axios from "axios";

export function getWarrantyHandoffDetail(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`/consumer/admin/api/v1/item-replacement/handoff/${id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
